export function peopleForOpenAssignmentDate(lastPeopleMap, taskId, lotId, date) {
  if (!taskId || !lotId || !date) return []

  const spans = lastPeopleMap[`${taskId}:${lotId}`] || []
  const match = spans.find((span) => date >= span.start && date <= span.end)
  return match?.people || []
}
